import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import * as React from "react";
import EmailIcon from "@material-ui/icons/Email";
import PersonIcon from "@material-ui/icons/Person";
import PhoneIcon from "@material-ui/icons/Phone";
import { Redirect } from "react-router-dom";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  profileData: any;
  companies: any;
}
class ProfileScreen extends React.Component<Props> {
  render() {
    const { classes, profileData } = this.props;
    return (
      <React.Fragment>
        {(!profileData || profileData === "undefined") && (
          <Redirect to="/segpi/" />
        )}
        {profileData && (
          <div>
            <List className={classes.root}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Full Name"
                  secondary={profileData.fullName}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <EmailIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Email Address"
                  secondary={profileData.email}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <PhoneIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Phone Number"
                  secondary={profileData.phone}
                />
              </ListItem>
            </List>
            <div
              style={{
                marginBottom: 20,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ProfileScreen);
